module.exports = __webpack_public_path__ + "img/xss_search_fixed-1.01805d9c.jpeg";